import { Album, Mapper, AnyAlbumEntityVersion, FirestoreEntity, Logger } from '@uploadcam/common';
import {
  and,
  CollectionReference,
  getDocs,
  or,
  query,
  QueryFilterConstraint,
  where,
} from 'firebase/firestore';
import { GetTeamGroupsInteractor } from '../../../team/domain/interactors/get-team-groups.interactor';

export class GetTeamAlbumsInteractor {
  constructor(
    private readonly albumsCollection: CollectionReference<AnyAlbumEntityVersion>,
    private readonly getTeamGroups: GetTeamGroupsInteractor,
    private readonly logger: Logger,
    private readonly mapper: Mapper<unknown, Album>,
  ) {}

  public async execute(teamId: string, userId?: string): Promise<Album[]> {
    try {
      const filters: QueryFilterConstraint[] = [where('teamId', '==', teamId)];

      if (userId) {
        const userGroupIds = (await this.getTeamGroups.execute(teamId, userId)).map(
          (group) => group.id,
        );

        const conditions: QueryFilterConstraint[] = [
          where('availableToDomainUsers', '==', true),
          where('users', 'array-contains', userId),
        ];

        if (userGroupIds.length > 0) {
          conditions.push(where('groups', 'array-contains-any', userGroupIds));
        }

        filters.push(or(...conditions));
      }

      const result = await getDocs(query(this.albumsCollection, and(...filters)));
      return result.docs.map((doc) => this.mapper.map(FirestoreEntity.from(doc)));
    } catch (error) {
      this.logger.error('An error occurred while getting documents:', error);
      throw error;
    }
  }
}
